import { cookieMgr, sortObject, groupBy } from '../utils'

const hashMap = {
	ru: 'Русские',
	//en: 'American',
	de: 'Deutsch',
	fr: 'Française',
	it: 'Italiano',
	jp: '日本人',
	cn: '日本人'
}

export default class Page {
	constructor() {
		this.$body = $(document.body);
		this.face = this.getFace();
		this.lang = this.getLang();
		this.selector = cookieMgr.get('categoryGroupSelector');
		this.cache = {
			$categoriesList: $('.tabs.categories_list')
		}
	}

	getFace() {
		return this.$body.attr('class').split(' ')[0].replace('face-', '');
	}

	getLang() {
		return this.$body.attr('class').split(' ')[1].replace('locale-', '');
	}

	init() {
		const isPornstarFace = this.face === 'pornstars';
		const isMainFace = this.face === 'main';
		const tabSelector = isPornstarFace ? 'pornstars' : this.selector;
		this.setTab(tabSelector);

		// if (isMainFace && hashMap[this.lang]) this.bumpCat('.tcats ul > li')
	}

	bumpCat(selector) {
		const $elems = $(selector)
		const mainCat = hashMap[this.lang]
		const $mainH3 = $elems.find(`h3:contains("${mainCat}")`)
		const $mainEl = $mainH3.parents('li')
		const $mainParent = $mainEl.parent()

		if ($mainEl.length === 0)
			return

		$mainEl.detach()
		$mainParent.prepend($mainEl)
	}

	alphabetical(selector, element, container) {
		const wrapperEl = document.createDocumentFragment();
		const $container = $(container);
		const $items = $(selector);

		let grouped = groupBy($items, element);
		let sortedGroup = sortObject(grouped, {
			All: $items.toArray()
		});

		Object.keys(sortedGroup).forEach(function(letter) {
			const spanEl = document.createElement('span');
			const $letterElems = $(sortedGroup[letter]);

			let classes = ['button'];
			if (letter === 'All')
				classes.push('current');

			spanEl.className = classes.join(' ');
			spanEl.textContent = letter;
			spanEl.addEventListener("click", e => {
				const $this = $(e.target);
				const $all = $container.children();

				$all.removeClass('current');
				$this.addClass('current');

				$items.hide();
				$letterElems.show();
			});

			wrapperEl.appendChild(spanEl);
		});

		$container.empty().prepend(wrapperEl);
	}

	setTab(selector) {
		if (!selector) return;

		var currentSelector = '.tabs__' + selector;
		var currentSelectorIndex = this.cache.$categoriesList.find('.tabs__panel').filter(currentSelector).index();

		var $tabs = this.cache.$categoriesList.find('.tabs__tab');
		var $panels = this.cache.$categoriesList.find('.tabs__panel');

		$($tabs[currentSelectorIndex]).addClass('is-active').siblings().removeClass('is-active');
		$($panels[currentSelectorIndex]).addClass('is-active').siblings().removeClass('is-active');
	}
}


// WEBPACK FOOTER //
// ./src/desktop/scripts/components/page.js